module.exports = __webpack_public_path__ + "img/why_img_3.1dfe5a41.png";